module.exports = __webpack_public_path__ + "static/media/CPlogo.b1ed755a.png";